module.exports = __webpack_public_path__ + "img/w3_bil_black.84c89a28.png";